import { FormControl } from '../EntryForm';
import { useController } from 'react-hook-form';
import { DateFormItem } from '../data/useProjectData/useProjectData';
import { Input } from '../component/Input';

interface Props {
	control: FormControl;
	formItem: DateFormItem;
	disabled?: boolean;
}

export const DateVariableInput = ({ control, formItem, disabled }: Props) => {
	const { field, fieldState } = useController({
		control,
		name: formItem.variable.variableName
	});

	return (
		<Input
			{...field}
			type="date"
			label={formItem.variable.variableLabel}
			error={fieldState.error?.message?.toString()}
			disabled={disabled || formItem.variable.entryType === 'calculated'}
			description={formItem.variable.description}
			obligatory={formItem.variable.obligatory}
			id={formItem.variable.variableName}
			hideFromUi={formItem.hideFromUi}
		/>
	);
};
